import React, { createContext, useState, useContext } from 'react';

const SlugContext = createContext({
  alternateSlug: {
    de: '',
    en: '',
  },
  setAlternateSlug: () => {},
});

export function SlugProvider({ children }) {
  const [alternateSlug, setAlternateSlug] = useState('');

  return (
    <SlugContext.Provider value={{ alternateSlug, setAlternateSlug }}>
      {children}
    </SlugContext.Provider>
  );
}

export const useSlug = () => useContext(SlugContext);
